/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgComputeNode = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        clipRule="evenodd"
        d="m19.707 4.293-2-2-1.414 1.414L18 5.414v5l.293.293L19.586 12l-1.293 1.293-.293.293v5l-1.707 1.707 1.414 1.414 2-2 .293-.293v-5l1.707-1.707.707-.707-.707-.707L20 9.586v-5zm-12-.586L6 5.414v5l-.293.293L4.414 12l1.293 1.293.293.293v5l1.707 1.707-1.414 1.414-2-2L4 19.414v-5l-1.707-1.707L1.586 12l.707-.707L4 9.586v-5l.293-.293 2-2zM8 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm5-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
        fill="currentcolor"
        fillRule="evenodd"
      />
    </g>
  </Icon>
);
export { SvgComputeNode as ComputeNode };
